// ======================================================================
// File: src/modules/ipe/dashboard/crm/components/CRMKpiCard.jsx
// Purpose:
// Executive KPI Card (Compact Version)
// ======================================================================

import React from "react";

export default function CRMKpiCard({
  title,
  value,
  trend,
  trendType = "up",
  icon,
  color = "#2563eb",
  sparkline = [],
  onClick,
}) {
  const trendColor =
    trendType === "up"
      ? "#16a34a"
      : trendType === "down"
      ? "#dc2626"
      : "#64748b";

  const trendIcon =
    trendType === "up"
      ? "▲"
      : trendType === "down"
      ? "▼"
      : "●";

  return (
    <div
      onClick={onClick}
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "12px",
        minHeight: "105px",
        cursor: onClick ? "pointer" : "default",
        boxShadow: "0 2px 10px rgba(0,0,0,.06)",
        border: "1px solid #e5e7eb",
        transition: "all .25s ease",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform =
          "translateY(-2px)";
        e.currentTarget.style.boxShadow =
          "0 8px 20px rgba(0,0,0,.10)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform =
          "translateY(0px)";
        e.currentTarget.style.boxShadow =
          "0 2px 10px rgba(0,0,0,.06)";
      }}
    >
      {/* TOP BORDER */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "3px",
          background: color,
        }}
      />

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "6px",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            color: "#64748b",
            fontWeight: 600,
            lineHeight: 1.2,
          }}
        >
          {title}
        </div>

        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: "10px",
            background: `${color}15`,
            color: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            flexShrink: 0,
          }}
        >
          <i className={icon}></i>
        </div>
      </div>

      {/* VALUE */}
      <div
        style={{
          fontSize: "18px",
          fontWeight: 700,
          color: "#111827",
          marginBottom: "4px",
          lineHeight: 1.2,
        }}
      >
        {value}
      </div>

      {/* TREND */}
      <div
        style={{
          color: trendColor,
          fontWeight: 600,
          fontSize: "11px",
          marginBottom: "6px",
        }}
      >
        {trendIcon} {trend}
      </div>

      {/* MINI SPARKLINE */}
      {sparkline.length > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: "2px",
            height: "16px",
          }}
        >
          {sparkline.map((v, index) => (
            <div
              key={index}
              style={{
                flex: 1,
                background: color,
                opacity: 0.7,
                borderRadius: "2px 2px 0 0",
                height: `${Math.max(
                  4,
                  Math.round(v * 0.4)
                )}px`,
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}